export default __webpack_public_path__ + "static/media/210.4f7acdbe.jpg";